"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulletItem = exports.BulletContainer = exports.colors = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.colors = [
    "var(--turquoise-dark)",
    "var(--pink)",
    "var(--pink-light)",
    "var(--warning)",
    "var(--snow-dark)",
];
exports.BulletContainer = styled_components_1.default.div.attrs({
    className: "BulletContainer",
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: auto 0.2rem;\n  display: flex;\n  align-items: center;\n"], ["\n  margin: auto 0.2rem;\n  display: flex;\n  align-items: center;\n"])));
exports.BulletItem = styled_components_1.default.div.attrs({
    className: "BulletItem",
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 0.8rem;\n  border-radius: ", ";\n  background-color: ", ";\n"], ["\n  padding: 0.8rem;\n  border-radius: ", ";\n  background-color: ", ";\n"])), function (props) { return props.borderRadius; }, function (props) { return exports.colors[props.index]; });
var templateObject_1, templateObject_2;
